module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon-上传-视频.2baa5.png";